import gql from 'graphql-tag';

const UPSERT_THROTTLE = gql`
  mutation upsertThrottle($params: UpsertThrottleInput!) {
    upsertThrottle(params: $params) {
      uuid
      name
      description
      min
      max
    }
  }
`;

export default UPSERT_THROTTLE;
